import { PatchFlightGroupType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const usePatchFlightGroup = () => {
	const queryClient = useQueryClient()

	return useMutation<void, Error, { tripId: string; flightGroupId: number; data: PatchFlightGroupType }>({
		mutationFn: async ({ tripId, flightGroupId, data }) => {
			await api.patch(`/trips/${tripId}/flights/flightGroups/${flightGroupId}`, data)
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.flights(variables.tripId) })
		},
	})
}
